<template>
    <div class="container">
        <div class="top-container">
            <p class="mini-title">My Journey</p>
            <p class="title">A balance of education and professional experience</p>
            <p class="description"> The story of where I've been and where I'm going.</p>
        </div>
        <div class="bottom-container">
            <div class="section">
                <p class="section-title">Education</p>
                <div class="card" v-for="edu in education">
                    <p class="card-title">{{ edu.courseName }}</p>
                    <div class="card-description">
                        <p class="left-description">{{ edu.institute }}</p>
                        <p class="right-description">{{ edu.duration }}</p>
                    </div>
                </div>
            </div>
            <div class="section">
                <p class="section-title">Work Experience</p>
                <div class="exp-card" v-for="exp in experience">
                    <div class="logo-wrapper" @click="openWebsite(exp.websiteUrl)">
                        <img :src="exp.logo" alt="">
                    </div>
                    <div class="card">
                        <p class="card-title">{{ exp.companyName }}</p>
                        <div class="card-description">
                            <p class="left-description">{{ exp.designation }}</p>
                            <p class="right-description">{{ exp.duration }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import codestaxLogo from '@/assets/icons/codestax-logo.svg';
import tcsLogo from '@/assets/icons/tcs-logo.png';
import fidelityLogo from '@/assets/icons/fidelity-logo.png'

export default {
    name: 'EducationAndExperience',
    data() {
        return {
            education: [
                {
                    courseName: 'B.Tech  - Information Technology',
                    institute: 'Institute of Road and Transport Technology, Erode',
                    duration: '2017 - 2021'
                }
            ],

            experience: [
                {
                    companyName: 'Fidelity Investments',
                    websiteUrl: 'https://www.fidelity.com/',
                    designation: 'Full Stack Developer',
                    duration: 'September 2024 to Present',
                    logo: fidelityLogo
                },
                {
                    companyName: 'Codestax.AI',
                    websiteUrl: 'https://www.codestax.ai',
                    designation: 'Software Development Engineer I',
                    duration: 'June 2023 to September 2024',
                    logo: codestaxLogo
                },
                {
                    companyName: 'Tata Consultancy Services',
                    websiteUrl: 'https://www.tcs.com',
                    designation: 'Assistant System Engineer',
                    duration: 'May 2021 to Jun 2023',
                    logo: tcsLogo
                },
            ]
        }
    },
    methods: {
        openWebsite(url) {
            if (url) {
                window.open(url, '_blank');
            }
        }
    }

}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 40px 120px;
    display: flex;
    flex-direction: column;
    gap: 60px;
}

.bottom-container {
    display: flex;
    gap: 80px;
    width: 100%;
}

.top-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.mini-title {
    font-size: 1.5rem;
    font-weight: 600;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.5rem;
}

.description {
    font-size: 1.2rem;
    color: var(--secondary-text-color)
}

.card {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.card-description {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
    row-gap: 12px;
}

.logo-wrapper img {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.logo-wrapper {
    border-radius: 50%;
    border: 1px solid #252626;
    background: #0C0C0D;
    display: flex;
    padding: 0.9rem;
    align-items: center;
    transition: all 0.3s ease-in-out;
    position: relative;
    cursor: pointer;
}

.exp-card {
    display: flex;
    gap: 16px;
    align-items: center;
}

.section-title {
    font-size: 1.5rem;
    font-weight: 600;
}

.card-title {
    font-size: 1.2rem;
    font-weight: 600;
}

.card-description p {
    font-size: 0.9rem;
    color: var(--secondary-text-color);
    white-space: nowrap;
}

@media (max-width: 900px) {
    .container {
        padding: 40px;
    }

    .bottom-container {
        flex-direction: column;
    }

    title {
        font-size: 2rem;
    }
}

@media (max-width: 700px) {
    .container {
        padding: 32px;
        gap: 1.5rem;
    }

    .top-container {
        text-align: center;
    }

    .card-description p {
        white-space: break-spaces;
    }

    .bottom-container {
        gap: 32px;
    }

    .skills img {
        width: 40px;
        height: 40px;
    }

    .mini-title {
        font-size: 1rem;
        width: 100%;
    }

    .description {
        font-size: 0.9rem;
    }

    .section-title {
        font-size: 1.2rem;
    }

    .title {
        font-size: 1.3rem;
        line-height: 1.5rem;
    }

    .card-title {
        font-size: 1rem;
    }


    .logo-wrapper img {
        width: 32px;
        height: 32px;
    }
}
</style>